import { Component, Input } from "@angular/core";

export type RiseAgentIconVariant = "onBlue" | "light" | "dark" | "adaptive";

@Component({
    selector: "app-rise-agent-icon",
    templateUrl: "./rise-agent-icon.component.html",
    styleUrls: ["./rise-agent-icon.component.scss"],
})
export class RiseAgentIconComponent {
    @Input() variant: RiseAgentIconVariant = "light";
    @Input() size: number = 20;
}
